module.exports = __webpack_public_path__ + "img/portrait-069.9cb93662.jpg";